import React, { useState, useEffect } from 'react';

// Import des images du Lady M encodées en base64
import { ladyExt1, ladyDeck, ladyExt2, ladyCabin, ladyAerial } from '../assets/boatImages';

const LandingPageEgypte = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [boatIdx, setBoatIdx] = useState(0);
  const [galIdx, setGalIdx] = useState(0);
  const [testiIdx, setTestiIdx] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const boatImgs = [ladyExt1, ladyDeck, ladyExt2, ladyCabin, ladyAerial];
  
  const galImgs = [
    'https://gillesdelieuze.com/wp-content/uploads/2024/10/snorkeler-with-dolphin-2023-11-27-05-14-46-utc-1-scaled.jpg',
    'https://gillesdelieuze.com/wp-content/uploads/2024/10/dolphins-swimming-underwater-in-ocean-2023-11-27-05-34-01-utc-scaled.jpg',
    'https://gillesdelieuze.com/wp-content/uploads/2024/10/dolphins-swimming-underwater-2024-09-16-12-51-33-utc-scaled.jpg',
    'https://gillesdelieuze.com/wp-content/uploads/2024/10/a-majestic-pod-of-dolphins-gliding-through-the-dee-2024-07-08-18-45-07-utc-1-scaled.jpg',
    'https://gillesdelieuze.com/wp-content/uploads/2024/10/atlantic-spotted-dolphin-stenella-frontalis-swi-2023-11-27-05-21-18-utc-scaled.jpeg',
    'https://gillesdelieuze.com/wp-content/uploads/2024/10/woman-snorkelling-underwater-with-snorkel-mask-in-2024-09-18-22-48-27-utc-scaled.jpg',
    'https://gillesdelieuze.com/wp-content/uploads/2023/04/Dauphins-Sataya-1-1024x676.png',
    'https://gillesdelieuze.com/wp-content/uploads/2023/11/Mer-Rouge-1024x680.png'
  ];

  const testiData = [
    {n:'Isabelle A.',i:'https://gillesdelieuze.com/wp-content/uploads/2023/12/IMG_20230602_1322042.jpg',s:"Il y a un avant et un apres... c'est indeniable.",t:"J'aimerais apporter mon temoignage en revenant sur cet incroyable voyage au pays des Dauphins et des Pyramides. Il etait une fois un homme tres inspirant, j'ai nomme Gilles Delieuze. Ce fut l'une des plus belles decisions que j'ai prise. Depuis l'age de 12 ans, je me suis dit : un jour je nagerai avec eux ! Ce qui m'en reste est tellement au-dela de mes reves les plus fous. Etre sur ce bateau, vivre 10 jours hors du temps, c'est etre connecte a l'essentiel du beau, du grand, du profond. C'est Etre. Tout simplement. Il y a un avant et un apres... c'est indeniable. Mon infinie gratitude a toi Gilles."},
    {n:'Nathalie',i:'https://gillesdelieuze.com/wp-content/uploads/2023/05/nathalie-PINAUD.jpg',s:"6 mois apres je shiftais 57 ans de vie parisienne.",t:"Le premier voyage avec les dauphins m'a permis de faire la paix avec mon aquaphobie en une semaine. Nager en leur compagnie m'a fait oublier le processus mental complexe de cette phobie. Tout est simple fluide quand on nage a leurs cotes. L'annee suivante, delivree de mon apprehension de l'eau, j'ai pu intercepter des messages delivres par les dauphins - leur regard est tres puissant. 6 mois apres je shiftais 57 ans de vie parisienne. Un voyage transformateur."},
    {n:'Celine',i:'https://gillesdelieuze.com/wp-content/uploads/2023/07/yoga-students2-1.png',s:"La plus belle experience de ma vie.",t:"La plus belle experience de ma vie. L'accompagnement de Gilles a magnifie cette rencontre que j'attendais depuis longtemps. Une connexion profonde avec ces etres merveilleux qui restera gravee dans mon coeur a jamais."},
    {n:'Helene',i:'https://gillesdelieuze.com/wp-content/uploads/2023/08/2_Home_Online_Training-Testimonials_3.jpg',s:"Il y a clairement un avant et un apres.",t:"C'est une experience tres profonde, il y a clairement un avant et un apres. Je le prenais en mode detente et je n'imaginais pas tout ce que j'allais connecter. Des prises de conscience majeures, une nouvelle Vie. Merci a Gilles pour la finesse de son accompagnement."},
    {n:'Simon',i:'https://gillesdelieuze.com/wp-content/uploads/2023/08/2_Home_Online_Training-Testimonials_1.jpg',s:"Une profondeur et une reliance rare et precieuse.",t:"Un moment de Grace renouvele. Je les avais deja rencontre mais voila 3 fois que je repars avec Gilles car j'y trouve une profondeur et une reliance rare et precieuse. Chaque voyage apporte son lot de revelations."},
    {n:'Roseline',i:'https://gillesdelieuze.com/wp-content/uploads/2023/12/IMG-20231008-WA0038.jpg',s:"Le meilleur voyage de ma vie tout simplement.",t:"Le meilleur voyage de ma vie tout simplement. J'y suis allee sans vraiment d'attente mais je suis repartie avec tellement plus. Une communion extraordinaire dans une baie remplie de Dauphins prets a vous donner de l'Amour, un groupe soude, et l'enseignement de Gilles. Une Renaissance et une Gratitude infinie."},
    {n:'Virginie',i:'https://gillesdelieuze.com/wp-content/uploads/2023/12/IMG_6504.jpeg',s:"Des instants de magie et communion d'une intensite rare.",t:"Trois Sataya deja, au plus pres des dauphins. Tellement de gratitude pour ce que je peux vivre, vibrer, ressentir la-bas. Des instants de magie et communion d'une intensite rare. Ta presence change tout Gilles. Je reviens chez moi toujours un peu changee, toujours plus libre."},
    {n:'Helene',i:'https://gillesdelieuze.com/wp-content/uploads/2023/12/566f956d-6506-4585-8354-e7bc1764834e.jpeg',s:"Une experience sacree guidee et amplifiee par Gilles.",t:"Partir nager avec les dauphins a Sataya peut paraitre un reve magique. En realite, cet endroit est une capsule facilitante. Au contact d'etres en cinq dimensions, divinement accompagne par Gilles Delieuze, vous decouvrirez ce que ce rendez-vous vous reserve. C'est toujours plus grand, plus inclusif, plus naturellement humain."},
    {n:'Marlene',i:'https://gillesdelieuze.com/wp-content/uploads/2023/12/68c220e0-0155-4f52-976f-527f142722bf.jpeg',s:"Une veritable retrouvaille, comme un retour a la maison originelle.",t:"Laissez-vous porter vers cette aventure merveilleuse. Un voyage hors du temps ou les jours semblent des semaines. La rencontre avec les dauphins a ete une veritable retrouvaille, comme un retour a la maison originelle. Merci a Gilles d'avoir fait de ce reve une realite au-dela de mes attentes."},
    {n:'Isabelle',i:'https://gillesdelieuze.com/wp-content/uploads/2023/12/68c220e0-0155-4f52-976f-527f142722bf.jpeg',s:"Bien plus que d'aller nager avec des dauphins.",t:"Bien plus que d'aller nager avec des dauphins, il s'agit d'une RENCONTRE d'un autre type. Dans ces eaux matricielles, c'est a une experience divinement humaine que Gilles nous convie. Evoluer avec ces Etres tellement aimants et accueillants. Une experience sacree guidee et amplifiee par Gilles. J'en suis encore impregnee a jamais."}
  ];

  const bookingUrl = "https://connect.shanti.om/book?destination=%C3%89gypte&programTitle=Voyage+initiatique+en+%C3%89gypte&programId=1301&startDate=2027-05-29&endDate=2027-06-06";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    
    // Fade in animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });
    
    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
    
    // Auto-rotate carousels
    const boatInterval = setInterval(() => setBoatIdx(i => (i + 1) % boatImgs.length), 5000);
    const galInterval = setInterval(() => setGalIdx(i => (i + 1) % galImgs.length), 4000);
    const testiInterval = setInterval(() => setTestiIdx(i => (i + 1) % testiData.length), 7000);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearInterval(boatInterval);
      clearInterval(galInterval);
      clearInterval(testiInterval);
    };
  }, []);

  const openModal = (idx) => {
    setModalData(testiData[idx]);
    setModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setModalOpen(false);
    document.body.style.overflow = '';
  };

  return (
    <div className="landing-egypte">
      {/* NAV */}
      <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-inner">
          <a href="#" className="nav-logo"><i className="fas fa-om"></i>Shanti Om</a>
          <ul className="nav-links">
            <li><a href="#infos">Infos</a></li>
            <li><a href="#destination">Destination</a></li>
            <li><a href="#bateau">Bateau</a></li>
            <li><a href="#temoignages">Temoignages</a></li>
            <li><a href="#tarifs">Tarifs</a></li>
            <li><a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="nav-btn">Reserver ma place</a></li>
          </ul>
          <button className="nav-toggle" onClick={() => setMobileMenuOpen(true)}><i className="fas fa-bars"></i></button>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <button className="mobile-close" onClick={() => setMobileMenuOpen(false)}><i className="fas fa-times"></i></button>
        <a href="#infos" onClick={() => setMobileMenuOpen(false)}>Infos</a>
        <a href="#destination" onClick={() => setMobileMenuOpen(false)}>Destination</a>
        <a href="#bateau" onClick={() => setMobileMenuOpen(false)}>Bateau</a>
        <a href="#temoignages" onClick={() => setMobileMenuOpen(false)}>Temoignages</a>
        <a href="#tarifs" onClick={() => setMobileMenuOpen(false)}>Tarifs</a>
        <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="nav-btn">Reserver</a>
      </div>

      {/* HERO */}
      <section className="hero">
        <div className="hero-bg">
          <img src="https://gillesdelieuze.com/wp-content/uploads/2024/10/a-majestic-pod-of-dolphins-gliding-through-the-dee-2024-07-08-18-45-07-utc-1-scaled.jpg" alt="Dauphins Sataya" />
        </div>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-badge">Voyage Initiatique 2027</span>
          <h1 className="hero-title">Communion avec les Dauphins<span>de Sataya</span></h1>
          <p className="hero-sub">29 mai - 06 juin 2027 | 9 jours / 8 nuits | Mer Rouge, Egypte</p>
          <p className="hero-desc">Offre-toi une semaine en mer, loin du bruit. Du bleu a 360 degres, du silence, des rencontres vraies. Et surtout : <strong>un reset</strong> - du corps, du coeur, et de cette part de toi qui veut redevenir simple.</p>
          <div className="hero-info">
            <span><i className="fas fa-star"></i>Avec Gilles Delieuze</span>
            <span><i className="fas fa-tag"></i>2 670 EUR</span>
            <span><i className="fas fa-users"></i>14-18 participants</span>
          </div>
          <div className="hero-btns">
            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="btn-gold">Plus d'informations</a>
            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="btn-outline">Je reserve ma place</a>
          </div>
        </div>
        <a href="#infos" className="scroll-indicator"><i className="fas fa-chevron-down"></i></a>
      </section>

      {/* STATS */}
      <section className="stats">
        <div className="stats-grid">
          <div className="stat-item fade-in"><div className="stat-num">11+</div><div className="stat-label">Annees d'experience</div></div>
          <div className="stat-item fade-in"><div className="stat-num">200+</div><div className="stat-label">Voyageurs transformes</div></div>
          <div className="stat-item fade-in"><div className="stat-num">9</div><div className="stat-label">Jours de communion</div></div>
          <div className="stat-item fade-in"><div className="stat-num">100%</div><div className="stat-label">Retours positifs</div></div>
        </div>
      </section>

      {/* INFOS */}
      <section className="section section-cream" id="infos">
        <div className="section-header fade-in">
          <span className="section-label">Les essentiels</span>
          <h2 className="section-title">Infos pratiques</h2>
        </div>
        <div className="info-grid">
          <div className="info-card fade-in"><div className="info-icon"><i className="fas fa-calendar-alt"></i></div><h3>Dates</h3><p>29 mai - 6 juin 2027</p></div>
          <div className="info-card fade-in"><div className="info-icon"><i className="fas fa-moon"></i></div><h3>Duree</h3><p>9 jours / 8 nuits</p></div>
          <div className="info-card fade-in"><div className="info-icon"><i className="fas fa-map-marker-alt"></i></div><h3>Destination</h3><p>Baie de Sataya, Mer Rouge</p></div>
          <div className="info-card fade-in"><div className="info-icon"><i className="fas fa-plane-arrival"></i></div><h3>Arrivee</h3><p>Hurghada (transferts inclus)</p></div>
          <div className="info-card fade-in"><div className="info-icon"><i className="fas fa-users"></i></div><h3>Groupe</h3><p>14 a 18 participants</p></div>
          <div className="info-card fade-in"><div className="info-icon"><i className="fas fa-ship"></i></div><h3>Hebergement</h3><p>7 nuits bateau + 1 nuit hotel</p></div>
          <div className="info-card fade-in"><div className="info-icon"><i className="fas fa-utensils"></i></div><h3>Pension</h3><p>Complete</p></div>
          <div className="info-card fade-in"><div className="info-icon"><i className="fas fa-user-tie"></i></div><h3>Accompagnement</h3><p>Gilles Delieuze</p></div>
        </div>
      </section>

      {/* PILLARS */}
      <section className="section section-dark">
        <div className="section-header fade-in">
          <span className="section-label">Notre signature</span>
          <h2 className="section-title">Pourquoi ce voyage est different</h2>
        </div>
        <div className="pillars-grid">
          <div className="pillar fade-in"><div className="pillar-num">01</div><h3>Quantic</h3><p>Une approche quantique exclusive et inedite pour une connexion profonde avec les dauphins.</p></div>
          <div className="pillar fade-in"><div className="pillar-num">02</div><h3>Soul</h3><p>Le supplement d'ame qui change tout. Une experience de renaissance interieure.</p></div>
          <div className="pillar fade-in"><div className="pillar-num">03</div><h3>Expert</h3><p>Communion humain-dauphin depuis 2007. Plus de 11 ans d'experience.</p></div>
          <div className="pillar fade-in"><div className="pillar-num">04</div><h3>Joy</h3><p>Humanisme, joie, conscience : une connexion inoubliable dans un groupe bienveillant.</p></div>
        </div>
      </section>

      {/* DESTINATION */}
      <section className="destination-section" id="destination">
        <div className="destination-grid">
          <div className="destination-content fade-in">
            <span className="section-label">La destination</span>
            <h2>Baie de Sataya : la maison des dauphins</h2>
            <p>Sataya est un recif preserve au sud de l'Egypte : un havre ou les dauphins viennent se reposer, jouer, socialiser.</p>
            <p>Le lagon est <strong>calme</strong>, la salinite aide a flotter : un cadre ideal, meme si tu n'es pas un nageur "technique".</p>
            <p>Et au-dela des dauphins : recifs coralliens, tortues, raies, poissons multicolores, pieuvres...</p>
            <div className="destination-features">
              <div className="dest-feat"><i className="fas fa-water"></i><span>Lagon calme et protege</span></div>
              <div className="dest-feat"><i className="fas fa-fish"></i><span>Biodiversite exceptionnelle</span></div>
              <div className="dest-feat"><i className="fas fa-sun"></i><span>Climat ideal en mai/juin</span></div>
              <div className="dest-feat"><i className="fas fa-swimmer"></i><span>Snorkeling accessible a tous</span></div>
            </div>
          </div>
          <div className="destination-images fade-in">
            <img src="https://gillesdelieuze.com/wp-content/uploads/2023/11/Mer-Rouge-1024x680.png" alt="Mer Rouge" />
            <img src="https://gillesdelieuze.com/wp-content/uploads/2023/04/Dauphins-Sataya-1-1024x676.png" alt="Dauphins Sataya" />
          </div>
        </div>
      </section>

      {/* ETHIQUE */}
      <section className="ethique-section">
        <div className="ethique-content fade-in">
          <span className="section-label" style={{color:'#C9A962'}}>Notre ethique</span>
          <h2>Une rencontre respectueuse. En conscience.</h2>
          <p>On privilegie des rencontres <strong>non intrusives</strong> : respect du rythme des dauphins, observation depuis le bateau quand c'est juste, et presence a l'eau quand l'invitation existe. Gilles vous permettra de vous connecter a la presence juste pour magnifier vos rencontres dans le respect, la conscience et la communion reciproques.</p>
        </div>
      </section>

      {/* QUOTE */}
      <section className="quote-section">
        <p className="quote-text fade-in">"La vie, ce n'est pas seulement respirer. C'est aussi avoir le souffle coupe."</p>
        <p className="quote-author fade-in">- Alfred Hitchcock</p>
      </section>

      {/* BATEAU */}
      <section className="section section-white" id="bateau">
        <div className="section-header fade-in">
          <span className="section-label">Votre hebergement</span>
          <h2 className="section-title">Un sejour confortable a bord</h2>
          <p className="section-desc">Le Lady M, 30m de longueur, 12 cabines climatisees avec salle de bain privative, espaces de detente ombrages, pont panoramique, bar avec boissons a volonte...</p>
        </div>
        <div className="boat-wrap">
          <div className="boat-main fade-in">
            <img src={boatImgs[boatIdx]} alt="Lady M - Bateau" />
            <button className="boat-nav prev" onClick={() => setBoatIdx((boatIdx - 1 + boatImgs.length) % boatImgs.length)}><i className="fas fa-chevron-left"></i></button>
            <button className="boat-nav next" onClick={() => setBoatIdx((boatIdx + 1) % boatImgs.length)}><i className="fas fa-chevron-right"></i></button>
          </div>
          <div className="boat-thumbs fade-in">
            {boatImgs.map((img, i) => (
              <div key={i} className={`boat-thumb ${i === boatIdx ? 'active' : ''}`} onClick={() => setBoatIdx(i)}>
                <img src={img} alt={`Lady M ${i+1}`} />
              </div>
            ))}
          </div>
          <div className="boat-features fade-in">
            <div className="boat-feat"><i className="fas fa-snowflake"></i><span>12 cabines climatisees</span></div>
            <div className="boat-feat"><i className="fas fa-bath"></i><span>Salles de bain privatives</span></div>
            <div className="boat-feat"><i className="fas fa-sun"></i><span>Pont panoramique</span></div>
            <div className="boat-feat"><i className="fas fa-umbrella-beach"></i><span>Espaces detente ombrages</span></div>
            <div className="boat-feat"><i className="fas fa-glass-cheers"></i><span>Bar a volonte</span></div>
            <div className="boat-feat"><i className="fas fa-water"></i><span>Acces facile a la mer</span></div>
            <div className="boat-feat"><i className="fas fa-bed"></i><span>Linge fourni</span></div>
            <div className="boat-feat"><i className="fas fa-user-friends"></i><span>Equipage attentionne</span></div>
          </div>
        </div>
      </section>

      {/* VIDEO TEMOIGNAGES */}
      <section className="video-section" id="temoignages">
        <div className="section-header fade-in">
          <span className="section-label" style={{color:'#C9A962'}}>Ils temoignent</span>
          <h2 className="section-title" style={{color:'#fff'}}>Ils en parlent mieux que moi</h2>
          <p className="section-desc">Ce qui revient le plus : "il y a un avant et un apres".</p>
        </div>
        <div className="video-wrap fade-in">
          <div className="video-container">
            <iframe src="https://www.youtube.com/embed/Ny3FHPt0tKY?rel=0" title="Temoignages Voyage Dauphin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>
      </section>

      {/* TEMOIGNAGES */}
      <section className="section section-cream">
        <div className="section-header fade-in">
          <span className="section-label">Temoignages</span>
          <h2 className="section-title">Ce qu'ils en disent</h2>
        </div>
        <div className="testi-wrap fade-in">
          {testiData.map((testi, i) => (
            <div key={i} className={`testi-card ${i === testiIdx ? 'active' : ''}`}>
              <div className="testi-quote"><i className="fas fa-quote-left"></i></div>
              <p className="testi-short">"{testi.s}"</p>
              <button className="testi-btn" onClick={() => openModal(i)}>Lire le temoignage complet <i className="fas fa-arrow-right"></i></button>
              <div className="testi-author">
                <img src={testi.i} alt={testi.n} />
                <div><h4>{testi.n}</h4><p>Voyageur(se) Sataya</p></div>
              </div>
            </div>
          ))}
          <div className="testi-nav">
            <button onClick={() => setTestiIdx((testiIdx - 1 + testiData.length) % testiData.length)}><i className="fas fa-chevron-left"></i></button>
            <button onClick={() => setTestiIdx((testiIdx + 1) % testiData.length)}><i className="fas fa-chevron-right"></i></button>
          </div>
          <div className="testi-dots">
            {testiData.map((_, i) => (
              <button key={i} className={`testi-dot ${i === testiIdx ? 'active' : ''}`} onClick={() => setTestiIdx(i)}></button>
            ))}
          </div>
        </div>
      </section>

      {/* VIDEO SOUVENIR */}
      <section className="video-section">
        <div className="section-header fade-in">
          <span className="section-label" style={{color:'#C9A962'}}>Souvenir</span>
          <h2 className="section-title" style={{color:'#fff'}}>Un apercu du voyage</h2>
        </div>
        <div className="video-wrap fade-in">
          <div className="video-container">
            <iframe src="https://www.youtube.com/embed/-cRRcREmHHA?rel=0" title="Voyage Sataya souvenir" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>
      </section>

      {/* GALERIE */}
      <section className="section section-white">
        <div className="section-header fade-in">
          <span className="section-label">Galerie</span>
          <h2 className="section-title">Moments de grace</h2>
        </div>
        <div className="gallery-wrap fade-in">
          <div className="gallery-main"><img src={galImgs[galIdx]} alt="Galerie" /></div>
          <div className="gallery-thumbs">
            {galImgs.map((img, i) => (
              <div key={i} className={`gallery-thumb ${i === galIdx ? 'active' : ''}`} onClick={() => setGalIdx(i)}>
                <img src={img} alt={`Galerie ${i+1}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TARIFS */}
      <section className="section section-dark" id="tarifs">
        <div className="section-header fade-in">
          <span className="section-label">Tarif & reservation</span>
          <h2 className="section-title">Rejoignez-nous</h2>
        </div>
        <div className="pricing-card fade-in">
          <div className="pricing-price">2 670<span>EUR</span></div>
          <p className="pricing-note">par personne (hors vols internationaux)</p>
          <div className="pricing-list">
            <div className="pricing-item"><i className="fas fa-check"></i>9 jours / 8 nuits pension complete</div>
            <div className="pricing-item"><i className="fas fa-check"></i>7 nuits bateau + 1 nuit hotel tout inclus</div>
            <div className="pricing-item"><i className="fas fa-check"></i>Tous transferts inclus</div>
            <div className="pricing-item"><i className="fas fa-check"></i>Accompagnement Gilles Delieuze</div>
            <div className="pricing-item"><i className="fas fa-check"></i>Nages quotidiennes avec les dauphins</div>
            <div className="pricing-item"><i className="fas fa-check"></i>Sessions d'enseignement quotidiennes</div>
          </div>
          <div className="pricing-btns">
            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="btn-gold">Je reserve ma place</a>
            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="btn-outline">Plus d'informations</a>
          </div>
        </div>
      </section>

      {/* BROCHURE PDF */}
      <section className="section section-white" id="brochure">
        <div className="section-header fade-in">
          <span className="section-label">Documentation complete</span>
          <h2 className="section-title">Decouvrez la brochure du voyage</h2>
          <p className="section-desc">Tous les details du sejour, le programme jour par jour, les informations pratiques...</p>
        </div>
        <div className="brochure-wrap fade-in">
          <div className="brochure-container">
            <iframe 
              src="https://docs.google.com/viewer?url=https://customer-assets-cm19k8pv.emergentagent.net/job_43a44300-a42f-40cc-bb12-078008e6fb02/artifacts/41lt2uoi_Shanti%20Om%20-%20Voyage%20Initiatique%20Egypte%20-%20Gilles%20Delieuze.pdf&embedded=true" 
              title="Brochure Voyage Egypte Shanti Om"
              className="brochure-viewer"
            ></iframe>
          </div>
          <div className="brochure-actions">
            <a 
              href="https://customer-assets-cm19k8pv.emergentagent.net/job_43a44300-a42f-40cc-bb12-078008e6fb02/artifacts/41lt2uoi_Shanti%20Om%20-%20Voyage%20Initiatique%20Egypte%20-%20Gilles%20Delieuze.pdf" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-gold"
            >
              <i className="fas fa-download"></i> Telecharger la brochure PDF
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section section-cream" id="faq">
        <div className="section-header fade-in">
          <span className="section-label">Vos questions</span>
          <h2 className="section-title">Questions frequentes</h2>
        </div>
        <div className="faq-wrap fade-in">
          <FaqItem question="Faut-il savoir nager ?" answer="Savoir nager et etre a l'aise en eau profonde est indispensable. Le voyage ne requiert aucune experience de la plongee. Des gilets de flottaison sont disponibles." />
          <FaqItem question="Quel niveau physique requis ?" answer="Aucun niveau particulier requis, chacun va a son rythme. Le voyage est accessible a tous." />
          <FaqItem question="Que faut-il apporter ?" answer="Maillot de bain, creme solaire, chapeau, vetements legers. Le linge de maison et serviettes sont fournis a bord." />
          <FaqItem question="Les vols sont-ils inclus ?" answer="Non, reservez votre vol jusqu'a Hurghada. Les transferts depuis/vers l'aeroport sont inclus dans le tarif." />
          <FaqItem question="Puis-je voyager seul(e) ?" answer="Oui ! Le tarif de base est sur chambre double partagee - nous pouvons vous jumeler avec un autre participant. Supplement single disponible : 1 150 EUR." />
        </div>
      </section>

      {/* GILLES */}
      <section className="section section-white">
        <div className="gilles-grid fade-in">
          <div className="gilles-img"><img src="https://gillesdelieuze.com/wp-content/uploads/2023/07/IMG_9885_www.vincentphotographie.com_-1024x683.jpg" alt="Gilles Delieuze" /></div>
          <div className="gilles-content">
            <h2>Votre accompagnant : Gilles Delieuze</h2>
            <p>Mentor, enseignant, auteur et therapeute depuis 25 ans en spiritualite incarnee, developpement personnel et leadership.</p>
            <p>J'accompagne les etres a changer de regard, a se pacifier avec l'existence et a reveler leur plein potentiel.</p>
            <p>Expert de la communion humain-dauphin depuis 2007, j'ai developpe une approche unique basee sur la conscience quantique et le respect profond du vivant.</p>
            <a href="https://www.shanti.om" target="_blank" rel="noopener noreferrer" className="gilles-link">En savoir plus <i className="fas fa-arrow-right"></i></a>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="cta-final">
        <h2 className="fade-in">Pret(e) a vivre cette experience unique ?</h2>
        <p className="fade-in">Plus que quelques places disponibles pour mai 2027. Rejoignez-nous pour 9 jours qui changeront votre vie.</p>
        <div className="hero-btns fade-in">
          <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="btn-gold">Je reserve ma place</a>
          <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="btn-outline">Plus d'informations</a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-grid">
          <div className="footer-brand"><h3><i className="fas fa-om"></i>Shanti Om</h3><p>Voyage initiatique en Egypte avec les dauphins sauvages de Sataya, Mer Rouge. Une experience de reconnexion profonde avec Gilles Delieuze.</p></div>
          <div className="footer-col"><h4>Navigation</h4><a href="#infos">Infos</a><a href="#destination">Destination</a><a href="#temoignages">Temoignages</a><a href="#tarifs">Tarifs</a></div>
          <div className="footer-col"><h4>Contact</h4><a href="https://www.shanti.om" target="_blank" rel="noopener noreferrer">www.shanti.om</a></div>
          <div className="footer-col"><h4>Legal</h4><a href="https://www.shanti.om" target="_blank" rel="noopener noreferrer">Mentions legales</a><a href="https://www.shanti.om" target="_blank" rel="noopener noreferrer">CGV</a></div>
        </div>
        <div className="footer-bottom"><p>2027 Shanti Om - Voyage bien-etre</p><p>www.shanti.om</p></div>
      </footer>

      {/* MODAL */}
      {modalOpen && modalData && (
        <div className="modal-overlay open" onClick={(e) => e.target.className.includes('modal-overlay') && closeModal()}>
          <div className="modal-box">
            <button className="modal-close" onClick={closeModal}><i className="fas fa-times"></i></button>
            <div className="modal-header">
              <img src={modalData.i} alt={modalData.n} />
              <div><h3>{modalData.n}</h3></div>
            </div>
            <div className="modal-text">{modalData.t}</div>
          </div>
        </div>
      )}
    </div>
  );
};

// FAQ Item component
const FaqItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item ${open ? 'open' : ''}`}>
      <button className="faq-q" onClick={() => setOpen(!open)}>
        <span>{question}</span>
        <i className="fas fa-chevron-down"></i>
      </button>
      <div className="faq-a">
        <div className="faq-a-inner">{answer}</div>
      </div>
    </div>
  );
};

export default LandingPageEgypte;
